export default __webpack_public_path__ + "static/media/Allahabad-Bank.7af8a701.webp";